import { createAction } from '@reduxjs/toolkit';
import { SmoMoonList } from '../../../../Models/Smo/SmoMoonList';
import { Optional } from '../../../../Utils/Types';

const resetState = createAction('MOON_LIST_RESET_STATE');
const getMoonListWithId = createAction<string>('MOON_LIST_GET_MOON_LIST_WITH_ID');
const setMoonList = createAction<Optional<SmoMoonList>>('MOON_LIST_SET_MOON_LIST');
const startRunWithMoonListId = createAction<string>('MOON_LIST_START_RUN_WITH_MOON_LIST_ID');
const deleteMoonListWithId = createAction<string>('MOON_LIST_DELETE_MOON_LIST_WITH_ID');

export default {
  resetState,
  getMoonListWithId,
  setMoonList,
  startRunWithMoonListId,
  deleteMoonListWithId
};
